import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { spring } from '../../utils/motion';
import { cn } from '../../utils/cn';
import type { GalleryItem } from '../../types/chef';
export function GalleryGrid({
  items
}: {
  items: GalleryItem[];
}) {
  const [active, setActive] = useState<GalleryItem | null>(null);
  const reduce = useReducedMotion();
  return <>
      <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3" data-id="element-345" data-mp="2hiq4yzzmup8a">
        {items.map((item, i) => <li key={item.id} className={cn(i === 0 && 'col-span-2 row-span-2 sm:col-span-2')} data-id="element-346" data-mp="2cnu0h0d7m9ea" data-mpi={i}>
            <button type="button" onClick={() => setActive(item)} className="group block h-full w-full overflow-hidden rounded-lg border border-hairline" data-id="element-347" data-mp="27or4s6j4dfiz">
              <img src={item.url} alt={item.caption} className={cn('h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]', i === 0 ? 'aspect-[4/3]' : 'aspect-square')} loading="lazy" data-id="element-348" data-mp="1yryn1a1kxqia" />
            </button>
          </li>)}
      </ul>

      <AnimatePresence data-id="element-349" data-mp="1s171amx3te17">
        {active && <div className="fixed inset-0 z-50 flex items-center justify-center p-5" role="dialog" aria-modal="true" aria-label={active.caption} data-id="element-350" data-mp="1s209ztfmidlz">
            <motion.button type="button" aria-label="Close image" onClick={() => setActive(null)} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2,
          ease: 'easeOut'
        }} className="absolute inset-0 bg-ink/70" data-id="element-351" data-mp="2kpw1mjqc5fbw" />
            <motion.figure initial={reduce ? {
          opacity: 0
        } : {
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={reduce ? {
          opacity: 0
        } : {
          opacity: 0,
          scale: 0.98
        }} transition={reduce ? {
          duration: 0.15
        } : spring.smooth} className="relative z-10 max-h-full w-full max-w-3xl overflow-hidden rounded-2xl bg-surface" data-id="element-352" data-mp="vd10kb3az5s7">
              <img src={active.url} alt={active.caption} className="max-h-[70vh] w-full object-cover" data-id="element-353" data-mp="2o81x3w0cts2d" />
              <figcaption className="flex items-center justify-between gap-4 px-5 py-3" data-id="element-354" data-mp="2j8flts436lw7">
                <span className="text-sm text-ink-2" data-id="element-355" data-mp="2e9m5lrxf0gsc">{active.caption}</span>
                <button type="button" onClick={() => setActive(null)} aria-label="Close image" className="rounded-lg p-1.5 text-ink-3 hover:bg-oat hover:text-ink" data-id="element-356" data-mp="2ebp4l1gjpk97">
                  <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-357" data-mp="7jfvryu87q7q" />
                </button>
              </figcaption>
            </motion.figure>
          </div>}
      </AnimatePresence>
    </>;
}